import request from '../utils/request.js'

export default {
  // 获取报名列表
  getList (params) {
    return request.post(`apply/lists`, params).then(res => res.data)
  },
  // 编辑
  edit (params) {
    return request.post(`jobs/add`, params).then(res => res.data)
  },
  // 获取报名详情
  details (params) {
    return request.post(`apply/details`, params).then(res => res.data)
  },
  // 获取报名信息
  applyInfo (params) {
    return request.post(`apply/get_apply_info`, params).then(res => res.data)
  },
  // 报名表预览
  applyView (params) {
    return request.post(`apply/apply_view`, params).then(res => res.data)
  },
  // 下载报名表
  downloadTable (params) {
    return request.post(`apply/down_apply_table`, params).then(res => res.data)
  },
  // 获取审核日志
  getLogList (params) {
    return request.post(`apply_log/lists`, params).then(res => res.data)
  },
  // 审核
  applyAudit (params) {
    return request.post(`apply/apply_audit`, params).then(res => res.data)
  },
  // 批量通过
  batchPass (params) {
    return request.post(`apply/batch_adopt`, params).then(res => res.data)
  },
  // 批量淘汰
  batchDelete (params) {
    return request.post(`apply/batch_eliminate`, params).then(res => res.data)
  },
  // 获取简历字段
  resumeFields (params) {
    return request.post(`apply/resume_fields`, params).then(res => res.data)
  },
  // 导出简历
  exportResume (params) {
    return request.post(`apply/export_resume`, params).then(res => res.data)
  },
  // 导出简历
  selectList (params) {
    return request.post(`apply/selectlist`, params).then(res => res.data)
  }
  ,
  //预览准考证
  ticket_view(params) {
    return request.post(`apply/ticket_view`, params).then(res => res.data)
  },
  // 下载准考证(mpdf)
  downTicket(params) {
    return request.post(`apply/down_apply_ticket`, params).then(res => res.data)
  },
  // 下载准考证(dompdf-效果更好)
  downTicketDompdf(params) {
    return request.post(`apply/down_apply_ticket_dompdf`, params).then(res => res.data)
  },
  // 下载报名表(dompdf)
  downApplyTableDompdf(params) {
    return request.post(`apply/down_apply_table_dompdf`, params).then(res => res.data)
  },
  // 递补操作
  supplement(params) {
    return request.post(`apply/supplement`, params).then(res => res.data)
  },

}



// WEBPACK FOOTER //
// ./src/api/apply.js